<template>
    <div class="theme-mode d-flex align-self-center">
        <button type="button" class="btn d-flex p-0 transparent noborder" @click="changeMode(switchToTheme.id)">
            <i :class="switchToTheme.icon" class="me-2" />&nbsp;
            <span class="ms-2">{{ $t('[[[Zmiana motywu]]]') }}</span>
        </button>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { $t } from '@/plugins/localization';

interface Theme {
    name: string;
    icon: string;
    id: number;
}

@Options({})
export default class ThemeMode extends Vue
{
    public themesList: Theme[] = [
        {
            name: $t('[[[Default mode]]]'),
            icon: 'fa-solid fa-lightbulb-on',
            id: 0
        },
        {
            name: $t('[[[Dark mode]]]'),
            icon: 'fa-solid fa-lightbulb-slash',
            id: 1
        }
    ];

    public changeMode(id: number): void
    {
        this.$store.commit('common/theme/changeMode', id);
    }

    public get switchToTheme(): Theme
    {
        return this.themesList.find(({ id }) => id !== this.themeModeId);
    }

    public get themeModeId(): number
    {
        return this.$store.state.common.theme.themeId;
    }
}
</script>

<style lang="scss">
.theme-dropdown .dropdown-menu {
    margin-top: 10px !important;
}
.btn-dropdown-white {
    box-shadow: none !important;
    background: transparent !important;
}
.theme-mode .btn span {
    text-transform: none;
    color: var(--cui-dropdown-link-color);
}
.theme-mode .btn .fa-solid {
    font-size: 13px;
    display: flex;
    align-items: center;
    color: var(--cui-dropdown-link-color);
}
.theme-mode .btn .fa-lightbulb-on {
    color: #e4e5e6;
}
.theme-mode .btn .fa-lightbulb-on + span {
    color: #e4e5e6;
}

</style>
